// You should use getStaticPaths if you’re statically pre-rendering pages that use dynamic routes
import { Hero } from '@/components/Hero'
import { statamicGraphqlEndpoint } from '@/globals/globals'
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Link,
  Stack,
  StackItem,
  Text,
} from '@chakra-ui/react'
import request, { gql } from 'graphql-request'
import { GetStaticProps } from 'next'

export const getStaticProps: GetStaticProps = async () => {
  let query = await request(
    statamicGraphqlEndpoint,
    gql`
      {
        entries(collection: "pages") {
          data {
            ... on Entry_Pages_PageEvents {
              intro
              events_list {
                address
                date
                event_link
                event_title
                map_link
              }
            }
          }
        }
      }
    `
  )

  const queryFiltered = query.entries.data.filter(
    (obj: any) => typeof obj.events_list !== 'undefined'
  )
  const events = queryFiltered.map((obj: any) => obj.events_list)

  return {
    props: {
      events: events[0],
    },
    revalidate: 60,
  }
}

type Event = {
  address: string
  date: string
  event_link: string
  event_title: string
  map_link: string
}

export const Page = ({ events }: { events: Event[] }) => {
  return (
    <>
      <Hero heading='Events'>
        <Container maxW='3xl'>
          <Text>
            As we make plans to attend various events throughout the year, plans
            are always subject to change. Please check our{' '}
            <Link
              textDecor='underline'
              href='https://www.instagram.com/debossgarage'>
              Instagram
            </Link>{' '}
            for the most up to date info.
          </Text>
        </Container>
      </Hero>
      <Container maxW='6xl' py={12}>
        <Stack spacing={6}>
          {events.map((event: Event, i: number) => (
            <StackItem key={i}>
              <Box
                py={4}
                px={8}
                borderWidth={2}
                borderColor='gray.200'
                display={['block', 'flex']}
                justifyContent='justify-between'>
                <div>
                  <Heading
                    pos='relative'
                    fontSize='display3'
                    fontWeight='bold'
                    mb={4}>
                    {event.event_title}
                  </Heading>
                  <Text fontWeight='bold' mb={2} textTransform='uppercase'>
                    {event.date}
                  </Text>
                  <address>{event.address}</address>
                </div>
                <Flex
                  textAlign='center'
                  justifyContent='space-between'
                  gridGap={4}
                  ml='auto'
                  pt={10}>
                  {event.map_link && (
                    <Button href={event.map_link} as='a' target='_blank'>
                      View Map
                    </Button>
                  )}
                  {event.event_link && (
                    <Button href={event.event_link} as='a' target='_blank'>
                      Event Website
                    </Button>
                  )}
                </Flex>
              </Box>
            </StackItem>
          ))}
        </Stack>
      </Container>
    </>
  )
}

export default Page
